import React, { useState, useEffect } from "react";
import Body from "../../Common/Body";
import moment from "moment";
import ContentCard from "../../Common/Layout/ContentCard";
import useFetch from "../../../hooks/useFetch";
import MinStockFilters from "./MinStockFilters";
import { MinStockTable } from "./MinStockTable";

const MinStock = () => {
  moment.locale();
  const [maxPagination, setMaxPagination] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataFetched, setDataFetched] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({});

  const { get } = useFetch();

  useEffect(() => {
    setIsLoading(true);
    let url = `/reports/min-stock?page=${currentPage}&`;
    Object.keys(filters).forEach((key) => {
      url += key + "=" + filters[key] + "&";
    });

    get(url)
      .then(async (res) => {
        setDataFetched(res);
        setMaxPagination(res.total);
      })
      .catch((e) => {
        console.log(e);
        throw new Error(e);
      })
      .finally(() => setIsLoading(false));
  }, [filters, currentPage]);

  const handleSelectedPage = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Body title={"Reporte de stock mínimo"}>
        <ContentCard>
          <MinStockFilters
            filters={filters}
            setFilters={setFilters}
          ></MinStockFilters>
        </ContentCard>
        <ContentCard>
          <MinStockTable
            isLoading={isLoading}
            maxPagination={maxPagination}
            currentPage={currentPage}
            products={dataFetched.products}
            handleSelectedPage={handleSelectedPage}
            setFilters={setFilters}
          ></MinStockTable>
        </ContentCard>
      </Body>
    </>
  );
};

export default MinStock;
